import qs from "qs"
import MobileDetect from "mobile-detect"

export function redirectToAppStoreUrl(url: string) {
  const {redirectToAppStore, utmSource, utmMedium, utm_source, utm_medium} = qs.parse(url)

  const utmSourceParam = utmSource || utm_source
  const utmMediumParam = utmMedium || utm_medium

  if (redirectToAppStore && utmSourceParam && utmMediumParam) {
    const detect = new MobileDetect(window.navigator.userAgent)
    const os = detect.os()

    if (os) {
      if (os === "iOS") {
        window.location.replace(
          `https://apps.apple.com/gb/app/perkbox/id1297386760?pt=2045312&mt=8&ct=${utmSourceParam}_${utmMediumParam}`
        )
      } else if (os === "AndroidOS") {
        window.location.replace(
          `https://play.google.com/store/apps/details?id=com.huddlebuy.perkbox&hl=en_GB&gl=US&referrer=utm_source%3D${utmSourceParam}%26utm_medium%3D${utmMediumParam}`
        )
      } else {
        window.location.replace(`https://www.perkbox.com/uk/app?utm_source=${utmSourceParam}&utm_medium=${utmMediumParam}`)
      }
    } else {
      window.location.replace(`https://www.perkbox.com/uk/app?utm_source=${utmSourceParam}&utm_medium=${utmMediumParam}`)
    }
  }
}
